const oAuth2Providers = {
  GOOGLE: 'GOOGLE',
  ONDA: 'ONDA'
};

export default oAuth2Providers;
